import { render, staticRenderFns } from "./AddNewSupplier.vue?vue&type=template&id=4e56104c&scoped=true"
import script from "./AddNewSupplier.vue?vue&type=script&lang=js"
export * from "./AddNewSupplier.vue?vue&type=script&lang=js"
import style0 from "./AddNewSupplier.vue?vue&type=style&index=0&id=4e56104c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e56104c",
  null
  
)

export default component.exports